"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sidenav.css");

var _sidenavUtils = _interopRequireDefault(require("../lib/sidenavUtils"));

var _utils = require("../lib/utils");

/* eslint-disable react/no-unused-prop-types */
var SideNav = function SideNav(props) {
  var dataTestId = props.dataTestId;
  var sidenavUtils = new _sidenavUtils["default"]();
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-sidenav-container")
  }, sidenavUtils.renderSideNav(props));
};

SideNav.propTypes = {
  items: _propTypes["default"].array.isRequired,
  onItemClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
SideNav.defaultProps = {
  onItemClick: function onItemClick() {},
  dataTestId: "orion-sidenav"
};
SideNav.displayName = "OrionSideNav";
var _default = SideNav;
exports["default"] = _default;